import * as validators from '_utils/validationChecks';
import { SitecoreFieldValidator } from '_utils/validationChecks/definitions'

export const careerProfileFormValidators: SitecoreFieldValidator[] = [
  {
    field: 'rendering.fields.data.datasource.myAccountLink',
    errorMessage: 'A valid link to the My Account page must be provided',
    required: true,
    validators: [validators.isValidLink]
  }
];
